import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popup from '../components/Popup'

export default class PopupPost extends Component {

  constructor(props) {
    super(props)
    this.state = {
      popupPostId: 0,
      opened: props.opened || false
    };
	}

  render() {
		const { post, opened } = this.props
    return (
			<Popup opened={opened} onClick={this.props.onClick} render={(children) => (
				<div>
					<h2>{post.title || post.position}</h2>
					<h4>Company: {post.company_name || post.company || post.companyname}</h4>
					<div className="term">{post.term || post.type || ''}</div>
					<div>{this.props.children}</div>
					<div className="clear"></div>
					<div className="description">{post.description ? <p dangerouslySetInnerHTML={{ __html: post.description && post.description }}></p> : <p>No description</p>}</div>
					<a href={post.url || post.applyurl} className="job-link" target="_blank">Read more</a>
				</div>
			)}/>
    )
  }
}

PopupPost.propTypes = {
  post: PropTypes.object.isRequired,
	opened: PropTypes.bool.isRequired,
	handleClose: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/PopupPost.js